module.exports = __webpack_public_path__ + "img/thunderstorm.d07d0968.jpg";